export type NavItem = {
  icon: React.ReactNode;
  label: string;
  path: string;
  translationKey: string;
  children?: NavItem[];
};

export function isNavItemActive(path: string, pathname: string): boolean {
  return path === '/' ? pathname === '/' : pathname.startsWith(path);
}
